import type { Project } from "@vorloop/api-client-react";
import { IconArrowRight } from "../layout/Icons";

const TYPE_LABEL: Record<Project["type"], string> = {
  mobile: "Mobile App",
  web: "Web App",
  component: "UI Component",
  backend: "Backend",
};

export function RecentProjects({ items }: { items: ReadonlyArray<Project> }) {
  return (
    <section style={{ width: "100%", maxWidth: 1040 }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 12,
        }}
      >
        <h2 style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>Your recent Projects</h2>
        <a
          href="/projects"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            color: "var(--text-secondary)",
          }}
        >
          View All
          <IconArrowRight />
        </a>
      </header>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 12,
        }}
      >
        {items.length === 0 && (
          <div
            style={{
              padding: 28,
              border: "1px dashed var(--border-default)",
              borderRadius: 12,
              color: "var(--text-tertiary)",
              fontSize: 13,
              textAlign: "center",
              gridColumn: "1 / -1",
            }}
          >
            No projects yet — pick a prompt above to start one.
          </div>
        )}
        {items.map((p) => (
          <a
            key={p.id}
            href={`/editor/${p.id}`}
            style={{
              border: "1px solid var(--border-default)",
              borderRadius: 12,
              background: "var(--bg-panel)",
              overflow: "hidden",
              color: "var(--text-primary)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              aria-hidden
              style={{
                height: 110,
                background:
                  p.type === "mobile"
                    ? "linear-gradient(135deg,#1f2937,#0f172a)"
                    : p.type === "web"
                      ? "linear-gradient(135deg,#1e293b,#0f172a)"
                      : "linear-gradient(135deg,#312e81,#0f172a)",
                borderBottom: "1px solid var(--border-default)",
              }}
            />
            <div style={{ padding: 12 }}>
              <div style={{ fontWeight: 600, fontSize: 13, lineHeight: 1.2 }}>{p.name}</div>
              <div style={{ fontSize: 11, color: "var(--text-tertiary)", marginTop: 4 }}>
                {TYPE_LABEL[p.type]}
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
